import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    rawAppData: {},
    appData: {},
    defaultLang: "fr",
    currentLang: "fr"
  },
  mutations: {
    setData: (state, data) => {
      state.rawAppData = data;
      state.appData = data[state.currentLang];
    },
    setLang: (state, lang) => {
      state.currentLang = lang;
      state.appData = state.rawAppData[state.currentLang];
    }
  }
});

export default store;
